module.exports = __webpack_public_path__ + "static/media/u23f3.19a91952.png";